import { useStoreMap } from 'effector-react'
import { supportModel } from '~/widgets/Support'
import { Content } from '~/widgets/Support/ui/styled'
import { SupportCmsBlockEnum } from '~/shared/config/enums'
import { DrawerComponent } from '~/shared/ui/Drawer'

type TrafficPoliceFinesDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function TrafficPoliceFinesDrawer({
  isShow,
  onClose,
}: TrafficPoliceFinesDrawerProps) {
  const [support] = useStoreMap(supportModel.$supports, (support) =>
    (support || [])?.map((support) => ({
      ...support.getAttributes(),
      id: support.getApiId() as UniqueId,
    })),
  ).filter(
    ({ position }) => position === SupportCmsBlockEnum.TRAFFIC_POLICE_FINES,
  )

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content
        dangerouslySetInnerHTML={{
          __html: support?.content || 'Контент не найден',
        }}
      />
    </DrawerComponent>
  )
}
